/* eslint-env jquery */
const $ = jQuery.noConflict();
let allRestaurants = [];
let prevInfoWindow = false;


'use strict';
const RestaurantStoreMap = {

	$restaurantTypeFilter: $('.js-dropdown-el'),
	$filterPlaceholder: $('.restaurant-guide-block__filter-btn .basic-text'),
	$selectedType: '',
	$mapBounds: '',
	$restaurantsCards: $('.restaurant-guide-block__cards'),
	$locationInput: $('.restaurant-guide-block__search-input'),
	$autosuggestDropdown: $('.restaurant-guide-block__search-dropdown'),
	$dropdownList: $('.dropdown_list-locations'),
	$dropdownListRestaurants: $('.dropdown_list-restaurants'),
	$zoomChangeExecuted: false,
	$allRestaurantPosts: [],
	$isMapLoaded: false,
	$selectedPlace: '',
	$selectedCity: '',
	$testGeolocation: false,
	$currentPage: 1,
	$cardPlaceholder: $(
		'<div class="restaurant-guide-block__card col-xl-6 col-md-6">' +
		'<div class="restaurant-guide-block__card-inner is-loading">' +
			'<div class="restaurant-guide-block__card-content">' +
			'<div class="restaurant-guide-block__card-title section-title section-title--small"></div>' +
			'<div class="restaurant-guide-block__map-link"></div>' +
			'<div class="restaurant-guide-block__card-type"></div>' +
			'<div class="restaurant-guide-block__card-certificate"></div>' +
			'</div>' +
		'</div>' +
		'</div>'
	),


	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: function() {
		if ($('.js-restaurant-map').length < 1) {
			return;
		}
		// Get the URL search parameters
		const searchParams = new URLSearchParams(window.location.search);

		// Check if the 'searched_place' parameter exists
		if (searchParams.has('searched_place')) {
			// Get the value of the 'searched_place' parameter
			let searchedPlace = searchParams.get('searched_place');
			searchedPlace = searchedPlace.replace('#038;', '');
			// eslint-disable-next-line quotes
			searchedPlace = searchedPlace.replace(/&#8217;/g, "'");
			console.log(searchedPlace);
			$('.restaurant-guide-block__search-input').val(searchedPlace);
		}
		RestaurantStoreMap.initMap($('.acf-restaurant-map'));
		RestaurantStoreMap.$locationInput.on('input', function() {
			RestaurantStoreMap.getAutosuggestedTerms();
		});

		// Handle Enter key press
		RestaurantStoreMap.$locationInput.on('keydown', function(event) {
			if (event.key === 'Enter' && RestaurantStoreMap.$selectedPlace !== '') {
				const allLocations = $('.dropdown-list.dropdown_list-locations');
				if (allLocations.find('li').length > 0) {
					const searchParams = new URLSearchParams(window.location.search);
					searchParams.set('searched_place', RestaurantStoreMap.$selectedPlace);
					searchParams.set('searched_city', RestaurantStoreMap.$selectedCity);
					window.location.search = searchParams.toString();
				} else {
					const allRestaurants = $('.dropdown-list.dropdown_list-restaurants');
					if (allRestaurants.find('li').length > 0) {
						allRestaurants.find('li').first().click();
					}
				}
			}
		});

		// Handle the button click
		$('.restaurant-guide-block__btn').on('click', function() {
			const allLocations = $('.dropdown-list.dropdown_list-locations');
			if (allLocations.find('li').length > 0) {
				if (RestaurantStoreMap.$selectedPlace !== '') {
					const searchParams = new URLSearchParams(window.location.search);
					searchParams.set('searched_place', RestaurantStoreMap.$selectedPlace);
					searchParams.set('searched_city', RestaurantStoreMap.$selectedCity);
					// Reload the page with the new URL parameter
					window.location.search = searchParams.toString();
				}
			} else {
				const allRestaurants = $('.dropdown-list.dropdown_list-restaurants');
				if (allRestaurants.find('li').length > 0) {
					allRestaurants.find('li').first().click();
				}
			}
		});

		$('.filters-search__search').on('click', function() {
			if ($(this).hasClass('field-focused') && $(this).val() !== '') {
				RestaurantStoreMap.$autosuggestDropdown.addClass('active-dropdown');
			} else if (RestaurantStoreMap.$autosuggestDropdown.hasClass('active-dropdown')) {
				RestaurantStoreMap.$autosuggestDropdown.removeClass('active-dropdown');
			}
		});

		$(document).on('click', function(event) {
			if (
				!$(event.target).closest('.restaurant-guide-block__search-field').length &&
				RestaurantStoreMap.$autosuggestDropdown.hasClass('active-dropdown')
			) {
				RestaurantStoreMap.$autosuggestDropdown.removeClass('active-dropdown');
			}
		});

		$(document).on('ajaxStart', function() {
			const cardCounter = $('.restaurant-guide-block__card').length;
			$('.restaurant-guide-post_cards').html('');
			// Append it 20 times
			for (let i = 0; i < cardCounter; i++) {
				$('.restaurant-guide-post_cards').append(RestaurantStoreMap.$cardPlaceholder.clone());
			}
		});

		// Add a click event listener to the ul element
		$('.dropdown_list-locations').on('click', 'li', function() {
			const selectedPlace = $(this).text();
			const selectedCity = $(this).data('state');
			const searchParams = new URLSearchParams(window.location.search);
			searchParams.set('searched_place', selectedPlace);
			searchParams.set('searched_city', selectedCity);
			// Reload the page with the new URL parameter
			window.location.search = searchParams.toString();
		});
		RestaurantStoreMap.newTabOpen();
	},

	initMap: (element) => {
		// Create generic map.
		const mapArgs = RestaurantStoreMap.getMapArgs(element);

		// eslint-disable-next-line no-undef
		const map = new google.maps.Map(element[0], mapArgs);

		// Add markers.
		map.markers = [];

		map.addListener('dragend', () => {
			// Clear page parameter from current URL
			RestaurantStoreMap.removePageParameterFromURL();
			// Get the current bounds of the map
			RestaurantStoreMap.$mapBounds = map.getBounds();

			if (RestaurantStoreMap.$mapBounds) {
				// Extract coordinates
				const ne = RestaurantStoreMap.$mapBounds.getNorthEast();
				const sw = RestaurantStoreMap.$mapBounds.getSouthWest();

				RestaurantStoreMap.ajaxRequest(ne, sw, map);
			}
			$('.state-found_restaurants').text('');
		});

		map.addListener('zoom_changed', () => {
			// Clear page parameter from current URL
			RestaurantStoreMap.removePageParameterFromURL();
			// Get the current bounds of the map
			RestaurantStoreMap.$mapBounds = map.getBounds();
			if (RestaurantStoreMap.$mapBounds) {
				$('.state-found_restaurants').text('');
				// Extract coordinates
				const ne = RestaurantStoreMap.$mapBounds.getNorthEast();
				const sw = RestaurantStoreMap.$mapBounds.getSouthWest();
				if($('.restaurant-guide-block__map-container').attr('data-loading') !== '1') {
					RestaurantStoreMap.ajaxRequest(ne, sw, map);
				}
			}
			RestaurantStoreMap.fetchAllRestaurantPosts();
		});

		RestaurantStoreMap.$restaurantTypeFilter.on('change', function() {
			RestaurantStoreMap.removePageParameterFromURL();
			RestaurantStoreMap.$selectedType = (RestaurantStoreMap.$restaurantTypeFilter.find('.is-active-checkbox input').val());
			if (RestaurantStoreMap.$selectedType === '') {
				RestaurantStoreMap.$filterPlaceholder.text('All Type');
			} else {
				RestaurantStoreMap.$filterPlaceholder.text(RestaurantStoreMap.$selectedType);
			}
			// Extract coordinates
			const ne = RestaurantStoreMap.$mapBounds.getNorthEast();
			const sw = RestaurantStoreMap.$mapBounds.getSouthWest();

			RestaurantStoreMap.ajaxRequest(ne, sw, map);
		});

		const searchParams = new URLSearchParams(window.location.search);
		if (searchParams.has('searched_place')) {
			let searchedPlace = searchParams.get('searched_place');
			searchedPlace = searchedPlace.replace('#038;', '');
			// eslint-disable-next-line quotes
			searchedPlace = searchedPlace.replace(/&#8217;/g, "'");
			console.log(searchedPlace);
			$.ajax({
				url: window.fwsLocalized.ajaxUrl,
				type: 'POST',
				dataType: 'JSON',
				data: {
					action: 'load-additional-posts',
					postTitle: decodeURIComponent(searchedPlace),
				},
				success: (response) => {
					RestaurantStoreMap.onAjaxSuccess(response, map);
					console.log(response);
				},
			});
		}

		// Attach a click event handler to restaurant suggestions
		RestaurantStoreMap.$dropdownListRestaurants.on('click', 'li.restaurant-item', function() {
			const postId = $(this).data('post-id'); // Retrieve the post ID from the clicked restaurant item
			// Make an AJAX request to fetch additional posts based on the clicked restaurant
			if(postId){
				$.ajax({
					url: window.fwsLocalized.ajaxUrl,
					type: 'POST',
					dataType: 'JSON',
					data: {
						action: 'load-additional-posts',
						postID: postId,
					},
					success: (response) => {
						RestaurantStoreMap.onAjaxSuccess(response, map);
					},
				});
			}
		});
		// Return map instance.
		RestaurantStoreMap.map = map;
		return map;
	},

	onAjaxSuccess: function(response, map) {
		$('.restaurant-guide-block__map-container').attr('data-loading', '1');
		// eslint-disable-next-line no-undef
		RestaurantStoreMap.$autosuggestDropdown.removeClass('active-dropdown');
		$('.currently-found_restaurants').html(response.PreparedData.length);
		RestaurantStoreMap.centerMap(RestaurantStoreMap.map);
		// eslint-disable-next-line no-undef
		const restaurantLatLng = new google.maps.LatLng(response.PreparedData[0].lat, response.PreparedData[0].lng);
		// Center the map on the selected restaurant's location
		const milesToMeters = 1609.34; // 1 mile is approximately 1609.34 meters
		const radiusInMeters = 25 * milesToMeters;
		// eslint-disable-next-line no-undef
		const circle = new google.maps.Circle({
			center: restaurantLatLng,
			radius: radiusInMeters,
		});
		// eslint-disable-next-line no-undef
		map.fitBounds(circle.getBounds());
		// eslint-disable-next-line no-undef
		map.setCenter(circle.getCenter());
		// Get the current bounds of the map
		// eslint-disable-next-line no-undef
		RestaurantStoreMap.$mapBounds = map.getBounds();
		if (RestaurantStoreMap.$mapBounds) {
			// Extract coordinates
			const ne = RestaurantStoreMap.$mapBounds.getNorthEast();
			const sw = RestaurantStoreMap.$mapBounds.getSouthWest();
			// eslint-disable-next-line no-undef
			RestaurantStoreMap.ajaxRequest(ne, sw, map);
		}
		$('.restaurant-guide-block__map-container').attr('data-loading', '0');
	},

	setMapToSearchedPlace: function(searchedPlace, map) {
		if (searchedPlace) {
			// Use the Google Geocoding service to get coordinates for the searched place
			// eslint-disable-next-line no-undef
			const geocoder = new google.maps.Geocoder();
			geocoder.geocode({address: searchedPlace}, function(results, status) {
				// eslint-disable-next-line no-undef
				if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
					const location = results[0].geometry.location;
					map.setCenter(location);
					// Set the zoom level to display a radius of 60 miles around the searched location
					const milesToMeters = 1609.34; // 1 mile is approximately 1609.34 meters
					const radiusInMeters = 25 * milesToMeters;
					// eslint-disable-next-line no-undef
					const circle = new google.maps.Circle({
						center: location,
						radius: radiusInMeters,
					});
					map.fitBounds(circle.getBounds());
					RestaurantStoreMap.$mapBounds = map.getBounds();
					// Extract coordinates
					const ne = RestaurantStoreMap.$mapBounds.getNorthEast();
					const sw = RestaurantStoreMap.$mapBounds.getSouthWest();

					RestaurantStoreMap.ajaxRequest(ne, sw, map);
					RestaurantStoreMap.$zoomChangeExecuted = true;
				}
			});
		}
	},

	calculateZoomLevel: function(map, viewport) {
		const MAX_ZOOM = 18;// Adjust as needed
		let latDiff = '';
		let lngDiff = '';
		if(viewport.La || viewport.eb){
			latDiff = viewport.La.hi - viewport.La.lo;
			lngDiff = viewport.eb.hi - viewport.eb.lo;
		} else {
			latDiff = viewport.Nh.hi - viewport.Nh.lo;
			lngDiff = viewport.di.hi - viewport.di.lo;
		}

		const latZoom = this.calculateSingleZoom(map.getDiv().offsetHeight, latDiff);
		const lngZoom = this.calculateSingleZoom(map.getDiv().offsetWidth, lngDiff);

		return Math.min(Math.min(latZoom, lngZoom), MAX_ZOOM);
	},

	calculateSingleZoom: function(dimension, diff) {
		const WORLD_DIM = 256;

		const fraction = diff / 360;

		return Math.floor(Math.log(dimension / WORLD_DIM / fraction) / Math.LN2);
	},

	fetchAllRestaurantPosts: function() {
		$.ajax({
			url: window.fwsLocalized.ajaxUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				action: 'load-all-restaurants',
			},
			success: (response) => {
				// Create an object or Map to store unique restaurant posts by id
				const uniquePosts = new Map();

				// Add or update the posts using their id as the key
				response.PreparedData.forEach(post => {
					uniquePosts.set(post.ID, post);
				});

				// Convert the values of the Map back to an array
				RestaurantStoreMap.$allRestaurantPosts = [...uniquePosts.values()];
			},
		});
	},

	getAutosuggestedTerms: function() {
		const query = RestaurantStoreMap.$locationInput.val();
		if (query.length >= 3) {
			// Fetch and display autosuggest results
			// eslint-disable-next-line no-undef
			const service = new google.maps.places.AutocompleteService();
			service.getPlacePredictions({input: query, componentRestrictions: {country: 'us'}}, (predictions, status) => {
				// eslint-disable-next-line no-undef
				if (status === google.maps.places.PlacesServiceStatus.OK) {
					// Display the suggestions in a dropdown or list
					// Each prediction has properties like description and place_id.
					RestaurantStoreMap.$autosuggestDropdown.addClass('active-dropdown');
					RestaurantStoreMap.$dropdownList.empty();
					RestaurantStoreMap.$selectedPlace = predictions[0].description;
					// Filter out predictions that contain the type 'restaurant'
					const filteredPredictions = predictions.filter(prediction => {
						return prediction.types.indexOf('point_of_interest') === -1;
					});
					filteredPredictions.forEach(prediction => {
						const li = $('<li class="location-item dropdown-text" data-state="'+ prediction.terms[0].value +'" style="cursor: pointer;">').text(prediction.description);
						RestaurantStoreMap.$dropdownList.append(li);
					});
				}
			});
			// Assuming query is a string of words separated by spaces
			const queryWords = query.toLowerCase().split(/\s+/);
			const numberSearched = queryWords.length;

			const filteredPosts = RestaurantStoreMap.$allRestaurantPosts.filter(post => {
				// Check if restaurant_address and title properties are defined
				if (post.restaurant_address && post.restaurant_address.title && post.title) {
					// Convert the strings to lowercase for case-insensitive comparison
					const lowercaseRestaurantTitle = post.restaurant_address.title.toLowerCase();
					const lowercasePostTitle = post.title.toLowerCase();

					// Concatenate restaurant title and post title, remove spaces
					const concatenatedTitles = (lowercaseRestaurantTitle + lowercasePostTitle);

					// Count the number of matched words in the concatenated string
					const matchedWordsCount = queryWords.reduce((count, word) => {
						if (concatenatedTitles.includes(word)) {
							return count + 1;
						}
						return count;
					}, 0);

					// Check that the post contains more than one element from the query when query has more than three elements
					if (numberSearched > 3 && matchedWordsCount < numberSearched - 1) {
						return false;
					}

					// Assign the matched word count to the post for later sorting
					post.matchedWordsCount = matchedWordsCount;

					// Adjust the condition based on your search requirements.
					return matchedWordsCount > 0;
				} else {
					// Handle the case where some properties are undefined
					return false;
				}
			});

			// Sort the filtered posts based on the number of matched words in descending order
			filteredPosts.sort((a, b) => b.matchedWordsCount - a.matchedWordsCount);
			RestaurantStoreMap.$dropdownListRestaurants.html('');
			if(filteredPosts.length !== 0) {
				// Create a Set to store unique posts
				const uniqueFilteredPosts = new Set(filteredPosts);

				// Convert the Set back to an array
				const uniqueFilteredPostsArray = [...uniqueFilteredPosts];
				RestaurantStoreMap.$dropdownListRestaurants.empty();
				uniqueFilteredPostsArray.forEach((post) => {
					const restaurantHtml = `
						<li style="cursor: pointer;" class="restaurant-item dropdown-text" data-post-id="${post.ID}">${post.title} <p class="date-subtitle date-subtitle--small">${post.restaurant_address.title}</p></li>
					`;
					RestaurantStoreMap.$dropdownListRestaurants.append(restaurantHtml);
				});
			}else {
				RestaurantStoreMap.$dropdownListRestaurants.append('No restaurants found');
			}
		}
	},

	autocompleteSearch: function() {
		// eslint-disable-next-line no-undef
		const autocomplete = new google.maps.places.Autocomplete(RestaurantStoreMap.$locationInput);

		autocomplete.addListener('place_changed', () => {
			const place = autocomplete.getPlace();
			if (!place.geometry) {
				// Handle no location found
				return;
			}
		});
	},

	getMapArgs: (element) => {
		return {
			zoom: element.data('zoom') || 16,
			// eslint-disable-next-line no-undef
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDefaultUI: true, //disables controls
			styles: [
				{
					'featureType': 'administrative',
					'elementType': 'all',
					'stylers': [
						{
							'visibility': 'on'
						}
					]
				},
				{
					'featureType': 'administrative',
					'elementType': 'geometry.fill',
					'stylers': [
						{
							'visibility': 'on'
						}
					]
				},
				{
					'featureType': 'administrative',
					'elementType': 'geometry.stroke',
					'stylers': [
						{
							'visibility': 'on'
						}
					]
				},
				{
					'featureType': 'administrative',
					'elementType': 'labels.text',
					'stylers': [
						{
							'visibility': 'on'
						}
					]
				},
				{
					'featureType': 'landscape',
					'elementType': 'all',
					'stylers': [
						{
							'visibility': 'on'
						}
					]
				},
				{
					'featureType': 'poi',
					'elementType': 'all',
					'stylers': [
						{
							'visibility': 'on'
						}
					]
				},
				{
					'featureType': 'road',
					'elementType': 'all',
					'stylers': [
						{
							'visibility': 'on'
						}
					]
				},
				{
					'featureType': 'transit',
					'elementType': 'all',
					'stylers': [
						{
							'visibility': 'on'
						}
					]
				},
				{
					'featureType': 'water',
					'elementType': 'all',
					'stylers': [
						{
							'visibility': 'on'
						}
					]
				}
			]
		};
	},

	initMarker: (location, map) => {
		// Get position from marker.
		const lat = location.data('lat');
		const lng = location.data('lng');
		const image = 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';
		// eslint-disable-next-line no-undef
		const marker = new google.maps.Marker({
			position: {
				lat: parseFloat(lat),
				lng: parseFloat(lng),
			},
			map: map,
			icon: image,
			// eslint-disable-next-line no-undef
			animation: google.maps.Animation.BOUNCE
		});

		// Append to reference for later use.
		map.markers.push(marker);

		// If marker contains HTML, add it to an infoWindow.
		if (location.html()) {
			// Create info window.
			// eslint-disable-next-line no-undef
			const infoWindow = new google.maps.InfoWindow({
				content: location.html()
			});
			// Show info window when marker is clicked.
			// eslint-disable-next-line no-undef
			google.maps.event.addListener(marker, 'click', function() {
				infoWindow.open(map, marker);
			});
		}
	},

	addMarkerFromJson: (pin, map) => {
		// eslint-disable-next-line no-undef
		const position = new google.maps.LatLng(pin.lat, pin.lng);
		let icon = '';
		// eslint-disable-next-line no-undef,camelcase
		icon = window.fwsLocalized.themeRoot + '/src/assets/images/OK_Map_Marker-1.png';

		// eslint-disable-next-line no-undef
		const marker = new google.maps.Marker({
			position: position,
			map: map,
			// eslint-disable-next-line no-undef,camelcase
			icon: icon
		});

		// add to array
		map.markers.push(marker);

		// if marker contains HTML, add it to an infoWindow
		if (pin.html) {
			// create info window
			// eslint-disable-next-line no-undef
			const infowindow = new google.maps.InfoWindow({
				content: pin.html
			});
			// show info window when marker is clicked
			// eslint-disable-next-line no-undef
			google.maps.event.addListener(marker, 'click', function() {
				if (prevInfoWindow) {
					prevInfoWindow.close();
				}
				prevInfoWindow = infowindow;
				infowindow.open(map, marker);
			});
			// eslint-disable-next-line no-undef
			google.maps.event.addListener(map, 'click', function() {
				infowindow.close();
			});
		}
		if (pin.str) {
			// create info window
			// eslint-disable-next-line no-undef
			const infoWindow = new google.maps.InfoWindow;

			infoWindow.setContent(pin.str);
			infoWindow.open(map, marker);
		}
	},

	centerMap: (map) => {
		const searchParams = new URLSearchParams(window.location.search);
		if (!searchParams.has('searched_place') && !RestaurantStoreMap.$isMapLoaded) {
			// Set the center to a specific location in America, for example, New York City
			const americaCenter = {lat: 40.7128, lng: -97.0060};
			map.setCenter(americaCenter);
			map.setZoom(3.2);
		} else if(!searchParams.has('searched_place')) {
			RestaurantStoreMap.handleMapFallback(map);
		}
	},

	handleMapFallback: function(map) {
		// eslint-disable-next-line no-undef
		const bounds = new google.maps.LatLngBounds();

		map.markers.forEach(function(marker) {
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng()
			});
		});
		// Case: Single marker.
		// eslint-disable-next-line eqeqeq
		if (map.markers.length === 1) {
			map.setCenter(bounds.getCenter());
			// Case: Multiple markers.
		} else {
			map.fitBounds(bounds);
		}

		RestaurantStoreMap.$isMapLoaded = true;
	},

	addMarkersFromResponse: (value) => {
		// eslint-disable-next-line no-unused-vars
		$.each(RestaurantStoreMap.map.markers, (i, marker) => {
			RestaurantStoreMap.map.markers[i].setMap(null);
		});

		// add markers
		$.each(value, (key, value) => {
			RestaurantStoreMap.addMarkerFromJson(value, RestaurantStoreMap.map);
		});
		RestaurantStoreMap.centerMap(RestaurantStoreMap.map);
	},


	// Render causes
	renderRestaurants: function(restaurant) {
		restaurant.PreparedData.forEach((el) => {
			const restaurantMarkup = this.getRestaurantMarkup(el);
			$('.restaurant-guide-post_cards').append(restaurantMarkup);
		});
	},


	// Get a restaurant card
	getRestaurantMarkup: function(restaurant) {
		const restaurantTitle = restaurant.data.title;
		const addressLink = restaurant.data.address_link;
		const addressText = restaurant.data.address_text;
		const restaurantType = restaurant.restaurant_type;
		const restaurantTypeDescription = restaurant.data.restaurantTypeDescription;
		const restaurantSVG = restaurant.restaurantSVG;
		const restaurantTypeSVG = restaurant.restaurantTypeSVG;
		const sertificateSVG = restaurant.sertificatSVG;
		const latestCertificate = restaurant.data.restaurant_licence;
		const restaurantTypes = restaurantType.map(type => `
			<span class="date-subtitle date-subtitle--small">${type.name}</span>
		`).join(', ');
		const typerestaurant = restaurantType.length > 0 ? `
		<div class="restaurant-guide-block__card-type">
			${restaurantTypeSVG}
			<div class="restaurant-guide-block__card-type--text">
			<span class="date-subtitle date-subtitle--small">${restaurantTypes}</span>
			<span class="date-subtitle date-subtitle--small type-info">${restaurantTypeDescription}</span>
			</div>
		</div>` : '';
		const certificateLink = latestCertificate.length > 0 ? `
			<a href="${latestCertificate}?timestamp=${Date.now()}" target="_blank" class="restaurant-guide-block__card-certificate">
				<div class="moving-underline"><span class="dropdown-text dropdown-text--brown">View Certificate</span></div>
				${sertificateSVG}
			</a>
		` : '';
		return `
		<div class="restaurant-guide-block__card col-xl-6 col-md-6">
			<div class="restaurant-guide-block__card-inner ajax-loaded_restaurant-cards">
				<div class="restaurant-guide-block__card-content">
				<div class="restaurant-guide-block__card-content--top">
					<h2 class="restaurant-guide-block__card-title section-title section-title--small">${restaurantTitle}</h2>
					<a href="${addressLink}" target="_blank" class="restaurant-guide-block__map-link">
						${restaurantSVG}
						<div class="restaurant-guide-block__map-link--text">
							<span class="date-subtitle date-subtitle--small">${addressText}</span>
						</div>
					</a>
						${typerestaurant}
				</div>
					${certificateLink}
				</div>
			</div>
		</div>
		`;
	},

	ajaxRequest: function(ne, sw, map, currentPage = RestaurantStoreMap.$currentPage = RestaurantStoreMap.getPageParameter(), perPage = 20) {
		const linksContainer = $('.pagination-links');
		const prevLink = $('.article__navigation-link--prev');
		const nextLink = $('.article__navigation-link--next');
		const centerLat = map.getCenter().lat();
		const centerLng = map.getCenter().lng();
		$.ajax({
			url: window.fwsLocalized.ajaxUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				action: 'filter_posts_by_bounds',
				swLat: sw.lat(),
				swLng: sw.lng(),
				neLat: ne.lat(),
				neLng: ne.lng(),
				centerLat: centerLat,
				centerLng: centerLng,
				restType: RestaurantStoreMap.$selectedType,
				page: currentPage,
				perPage: perPage,
			},
			success: (response) => {
				$('.article__navigation-link').show();
				$('.pagination-links').show();
				if (!response || response.PreparedData.length === 0) {
					$('.restaurant-guide-block__card-counter').html('');
					// Clear existing markers
					clearMarkers(map);
					$('.restaurant-guide-post_cards').html('<div class="no-results-restaurants_found">No restaurants found</div>');
					$('.article__navigation-link').hide();
					$('.pagination-links').hide();
				} else {
					$('.restaurant-guide-post_cards').html('');
					// Clear existing markers
					clearMarkers(map);
					allRestaurants = [];
					$('.restaurant-guide-post_cards').find('.restaurant-guide-block__card').remove();
					response.PreparedData.forEach(element => {
						allRestaurants.push(element);
					});
					RestaurantStoreMap.renderRestaurants(response);
					$('.restaurant-guide-block__card-counter').html('<p class="pre-title--small pre-title"><span class="is-found_restaurant">' + ((parseInt(currentPage - 1) * parseInt(perPage)) + 1) + '</span> - <span class="currently-found_restaurants">' + ((parseInt(currentPage - 1) * parseInt(perPage)) + parseInt(response.PreparedData.length)) + '</span> of <span class="all-found_restaurants">' + response.AllFound + '</span> restaurants</p>');

					addMarkers(map, allRestaurants);
					// Update the pagination links
					linksContainer.empty();
					prevLink.hide();
					nextLink.hide();
					// Previous link
					prevLink.show();
					prevLink.attr('href', RestaurantStoreMap.updateQueryStringParameter(window.location.href, 'paged', parseInt(currentPage) - 1));
					(currentPage > 1) ? prevLink.removeClass('disabled') : prevLink.addClass('disabled');

					prevLink.off('click').on('click', function(event){
						event.preventDefault();
						const newUrl = RestaurantStoreMap.updateQueryStringParameter(window.location.href, 'paged', parseInt(currentPage) - 1);
						window.history.pushState({path: newUrl}, '', newUrl);

						// Now you can load the content for the new page using your ajaxRequest function
						RestaurantStoreMap.ajaxRequest(ne, sw, map); // Use your parameters
						// Scroll to the top of the element with ID 'myDiv'
						const targetElement = $('#restaurant-guide-block');
						if (targetElement.length) {
							$('html, body').animate({
								scrollTop: targetElement.offset().top
							}, 'slow');
						}
					});
					// pagination item + links
					if (response.MaxNum > 1) {
						const urlParams = new URLSearchParams(window.location.search);
						const currentPage = parseInt(urlParams.get('paged')) || 1;
						const linksContainer = $('.pagination-links');
						// Function to add a page link to the container
						const addPageLink = (pageNumber, isActive = false) => {
							const pageLink = document.createElement('a');
							pageLink.href = RestaurantStoreMap.updateQueryStringParameter(window.location.href, 'paged', pageNumber);
							pageLink.textContent = pageNumber;
							pageLink.classList.add('paged-' + pageNumber);
							if (isActive) {
								pageLink.classList.add('is_active');
							}
							linksContainer.append(pageLink);
							pageLink.addEventListener('click', function(event) {
								event.preventDefault();
								const pageValue = pageNumber;
								const newUrl = RestaurantStoreMap.updateQueryStringParameter(window.location.href, 'paged', pageValue);
								window.history.pushState({path: newUrl}, '', newUrl);
								RestaurantStoreMap.ajaxRequest(ne, sw, map); // Use your parameters
								$(this).addClass('is_active');
								const targetElement = $('#restaurant-guide-block');
								if (targetElement.length) {
									$('html, body').animate({
										scrollTop: targetElement.offset().top
									}, 'slow');
								}
							});
						};
						// Show the first page
						addPageLink(1, currentPage === 1);
						// Show the pages around the current page
						if (currentPage > 3) {
							linksContainer.append('<span>...</span>'); // Add ellipsis if skipping pages
						}
						for (let i = Math.max(2, currentPage - 1); i <= Math.min(response.MaxNum - 1, currentPage + 2); i++) {
							addPageLink(i, currentPage === i);
						}
						// Show the last page
						if (currentPage < response.MaxNum - 2) {
							linksContainer.append('<span>...</span>'); // Add ellipsis if skipping pages
						}

						addPageLink(response.MaxNum, currentPage === response.MaxNum);
					}


					// Next link
					nextLink.show();
					nextLink.attr('href', RestaurantStoreMap.updateQueryStringParameter(window.location.href, 'paged', parseInt(currentPage) + 1));
					(currentPage < response.MaxNum) ? nextLink.removeClass('disabled') : nextLink.addClass('disabled');
					nextLink.off('click').on('click', function(event){
						event.preventDefault();
						const newUrl = RestaurantStoreMap.updateQueryStringParameter(window.location.href, 'paged', parseInt(currentPage) + 1);
						window.history.pushState({path: newUrl}, '', newUrl);

						// Now you can load the content for the new page using your ajaxRequest function
						RestaurantStoreMap.ajaxRequest(ne, sw, map); // Use your parameters
						// Scroll to the top of the page
						// Scroll to the top of the element with ID 'myDiv'
						const targetElement = $('#restaurant-guide-block');
						if (targetElement.length) {
							$('html, body').animate({
								scrollTop: targetElement.offset().top
							}, 'slow');
						}
					});
				}
			},
			error: (jqXHR, textStatus, errorThrown) => {
				// Handle the error condition
				console.error(`AJAX request failed: ${textStatus}, ${errorThrown}`);
			},
		});

		// Function to clear existing markers
		function clearMarkers(map) {
			for (const marker of map.markers) {
				marker.setMap(null);
			}
			map.markers = [];
		}

		// Function to add new markers
		function addMarkers(map, markers) {
			for (const markerData of markers) {
				RestaurantStoreMap.addMarkerFromJson(markerData, map);
			}
		}
	},

	// Function to check if the current URL has a "page" parameter and get its value
	getPageParameter: function() {
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has('paged')) {
			return urlParams.get('paged');
		}
		return 1; // Return 1 if "page" parameter is not present
	},

	// Function to update URL query parameters
	updateQueryStringParameter: function(uri, key, value) {
		const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
		const separator = uri.indexOf('?') !== -1 ? '&' : '?';
		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + '=' + value + '$2');
		} else {
			return uri + separator + key + '=' + value;
		}
	},

	removePageParameterFromURL: function() {
		const url = window.location.href;
		const urlObject = new URL(url);

		// Check if the 'page' parameter exists
		if (urlObject.searchParams.has('paged')) {
			// Remove the 'page' parameter
			urlObject.searchParams.delete('paged');

			// Replace the current URL with the modified URL (without the 'page' parameter)
			window.history.replaceState({}, document.title, urlObject.toString());
		}
	},

	newTabOpen: function() {
		$('.restaurant-guide-banner__content a').attr('target', '_blank');
	}
};

export default RestaurantStoreMap;
